import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import authReducer from './authReducer';
import userReducer from './userReducer';

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    user: userReducer,
  });

export default createRootReducer;
